import { render, staticRenderFns } from "./ParticipateCardGame.vue?vue&type=template&id=90aee3be&scoped=true"
import script from "./ParticipateCardGame.vue?vue&type=script&lang=js"
export * from "./ParticipateCardGame.vue?vue&type=script&lang=js"
import style0 from "./ParticipateCardGame.vue?vue&type=style&index=0&id=90aee3be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90aee3be",
  null
  
)

export default component.exports